import {
  TICKET_LIST,
  TICKET_CREATE,
  TICKET_FILTER,
  TICKET_UPDATE,
  CONSIGNMENT_CREATE,
  CONSIGNMENT_CREATE_SUCCESS,
  CONFISCATION_CREATE,
  CONFISCATION_CREATE_SUCCESS,
  TICKET_CREATE_SUCCESS,
  TICKET_LIST_SUCCESS,
  TICKET_UPDATE_SUCCESS,
  INVOICE_CREATE,
  INVOICE_UPDATE,
  INVOICE_UPDATE_SUCCESS,
  INVOICE_CREATE_SUCCESS,
  BILLING_REQUEST_FAILED,
} from "store/billing/actionTypes";

// Tickets
export const ticketList = () => {
  return {
    type: TICKET_LIST,
    payload: {},
  };
};

export const ticketCreate = (ticket) => {
  return {
    type: TICKET_CREATE,
    payload: ticket,
  };
};

export const ticketFilter = (changeUrl) => {
  return {
    type: TICKET_FILTER,
    payload: { changeUrl },
  };
};

export const ticketUpdate = (id, data) => {
  return {
    type: TICKET_UPDATE,
    payload: { id, data },
  };
};

export const invoiceCreate = (invoice) => {
  return {
    type: INVOICE_CREATE,
    payload: invoice,
  };
};

export const invoiceUpdate = (id, data) => {
  return {
    type: INVOICE_UPDATE,
    payload: { id, data },
  };
};

export const ticketListSuccess = (tickets) => {
  return {
    type: TICKET_LIST_SUCCESS,
    payload: tickets,
  };
};

export const ticketCreateSuccess = (ticketCreated) => {
  return {
    type: TICKET_CREATE_SUCCESS,
    payload: ticketCreated,
  };
};

export const ticketUpdateSuccess = (ticket) => {
  return {
    type: TICKET_UPDATE_SUCCESS,
    payload: ticket,
  };
};

export const invoiceCreateSuccess = (invoiceCreated) => {
  return {
    type: INVOICE_CREATE_SUCCESS,
    payload: invoiceCreated,
  };
};

export const invoiceUpdateSuccess = (invoice) => {
  return {
    type: INVOICE_UPDATE_SUCCESS,
    payload: invoice,
  };
};

// Consignments

export const consignmentCreate = (consignment) => {
  return {
    type: CONSIGNMENT_CREATE,
    payload: consignment,
  };
};

export const consignmentCreateSuccess = (consignmentCreated) => {
  return {
    type: CONSIGNMENT_CREATE_SUCCESS,
    payload: consignmentCreated,
  };
};

// Confiscations

export const confiscationCreate = (confiscation) => {
  return {
    type: CONFISCATION_CREATE,
    payload: confiscation,
  };
};

export const confiscationCreateSuccess = (confiscationCreated) => {
  return {
    type: CONFISCATION_CREATE_SUCCESS,
    payload: confiscationCreated,
  };
};

export const billingRequestFailed = (error) => {
  return {
    type: BILLING_REQUEST_FAILED,
    payload: error,
  };
};
